
/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */


import * as Utils from '@Cyclope-Utils/index';
import {ChangePassWordActionFail, ChangePassWordActionInProgress, ChangePassWordActionSuccess} from '@tunnel-store/index';
import {Dispatch} from 'redux';


/**
 * @function { ChangePassWordActionCreator }
 * @param { any } userPassword
 * @return {Promise<any>}  Promise
 */

export function ChangePassWordActionCreator(userPassword: any): (
    dispatch: Dispatch<any>, {}) => Promise<any> {
  return async (dispatch: Dispatch<any>) => {
    dispatch(ChangePassWordActionInProgress());

        await Utils.changeUserPassWord(userPassword) // 
        // .then((res: any) => {
        // if( res.ok ){ dispatch(ChangePassWordActionSuccess("your password has been modified ("+Math.random()+ ")"))     
        // }else{ dispatch(ChangePassWordActionFail("server error has occurred with HTTP status ("+res.status+ ")"+Math.random()+"" ))}
        // }) 
        // .catch( (error : any) => dispatch(ChangePassWordActionFail(error)))  
        
        
        .then((response: any)=> {
      if (response.ok) {
        /**
         * @constant
         * @name contentHeader 204
         * @type string
         */
        const contentHeader: string = response.headers.get('content-type');
        { /* Comparer les valeurs */
        }
        if (contentHeader && contentHeader !== null &&
            contentHeader.indexOf('application/json') !== -1) {
          if (response.status === 200 || response.status === 204) {
            { /** Renvoie une promise qui retourne le résultat en JSON  */
            }
            response.json().then(
                (data: any) => dispatch(ChangePassWordActionSuccess(
                    [])));  // État du state : resultat final
          }

          else if (response.status === 203) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.json().then(
                (text: any) => dispatch(ChangePassWordActionSuccess(
                    [])))  // État du state : resultat final
          }
        }
        if (contentHeader === null || contentHeader === undefined) {
          if (response.status === 203) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.text().then(
                (text: any) => dispatch(ChangePassWordActionSuccess(
                    [])))  // État du state : resultat final
          } else if (response.status === 204) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.text().then(
                (text: any) => dispatch(ChangePassWordActionSuccess(
                    [])))  // État du state : resultat final
          }
        }
      } else {
        throw ({
          message: response.statusText,
          status: response.status,
          url: response.url,
          headers: response.headers
        });
      }}).catch( (error: any) => {
                dispatch(ChangePassWordActionFail(error.status + ' -- ' + Math.random())) /* { // État du state : échec  }*/
                Utils.fetchLogs(error.url,error.message,error.status,error.headers)
            })
  }
}



// WEBPACK FOOTER //
// ./src/apps/tunnel/store/actionsCreator/actions/changepassword/index.ts